import React from "react";
import useThunkReducer from "../../HOC/useThunkReducer";
import {feedbackReducer, initialState} from "./reducer";

export const FeedBackContext = React.createContext({});

const FeedBackContextWrapper = ({children}) => {
    const [state, dispatch] = useThunkReducer(
      feedbackReducer,
        initialState
    );
    return (
        <FeedBackContext.Provider value={{
            state,
            dispatch,
        }}>{children}</FeedBackContext.Provider>
    );
};

export default FeedBackContextWrapper;
